import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class SalesArea extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: false,
			salesArea: ''
		};
	}

	toggleSelect = () => {
		this.setState({dropdownOpen: !this.state.dropdownOpen})
	}

	onClick = (salesArea) => {
		this.setState({salesArea: salesArea.Label});
		this.props.updateProductList(salesArea.ID);
	}

	render() {
		const {dropdownOpen, salesArea} = this.state;
		return (
			<>
			{
			this.props.salesArea && <Dropdown isOpen={dropdownOpen} toggle={this.toggleSelect}>
				<DropdownToggle caret>
					{salesArea === '' && this.props.salesArea[0] ?
					 this.props.salesArea[0].Label : salesArea}
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem header>Sales Area</DropdownItem>
					{this.props.salesArea && this.props.salesArea.map(s => {
						return (
							<DropdownItem key={s.ID} onClick={() => this.onClick(s)}>
								{s.Label}
							</DropdownItem>
						);
					})}
				</DropdownMenu>
			</Dropdown>
			}
			</>
		);
	}
}

export default SalesArea;
